import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { SchoolActivityService } from 'app/services/school-activity.service';
import { UserService } from 'app/services/user.service';
import { combineLatest, of, Subject, switchMap, takeUntil } from 'rxjs';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'sp-live-update-subscriber',
	template: '',
})
export class LiveUpdateSubscriberComponent implements OnInit, OnDestroy {
	constructor(private userService: UserService, private schoolActivityService: SchoolActivityService) {}

	private destroy$ = new Subject<void>();

	ngOnInit(): void {
		this.userService.user$
			.pipe(
				switchMap((user) => {
					if (user.isStudent()) {
						// TODO: handle student events
					} else if (user.isStaff()) {
						return combineLatest([
							this.schoolActivityService.watchActivityInstanceEventsForTeacher(),
							this.schoolActivityService.watchActivityAttendeeEventsForTeacher(),
						]);
					}

					return of(null);
				}),
				takeUntil(this.destroy$)
			)
			.subscribe();
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}
}
